import { Link } from 'react-router-dom';
import { getFeaturedArticles, getRecentArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();
  const recent = getRecentArticles(6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            编辑精选的高质量同人创作指南文章
          </p>
        </div>

        <div className="space-y-6 mb-12">
          {featured.slice(0, 2).map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            最新文章
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            持续更新的同人创作知识与文化解读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {recent.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/character-analysis"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-background-100 text-foreground-700 px-6 py-3 rounded-full text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}